import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";

const SubscriptionTable = ({ refreshTrigger }) => {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const navigate = useNavigate();

  const fetchSubscriptions = async () => {
    try {
      const response = await Api.fetchSubscription();
      const subscriptions = Array.isArray(response.data) ? response.data : [];

      const columns = [
        { Header: "ID", accessor: "id", width: "10%", align: "left" },
        { Header: "Name", accessor: "name", align: "left" },
        { Header: "Validity", accessor: "validity_days", align: "center" },
        { Header: "Expiry Date", accessor: "expiry_date", align: "center" },
        { Header: "Allowed Devices", accessor: "allowed_number_of_devices", align: "center" },

        { Header: "Sell Price", accessor: "sell_price", align: "center" },
        { Header: "Original Price", accessor: "original_price", align: "center" },
        { Header: "description", accessor: "description", align: "center" },
        { Header: "status", accessor: "status", align: "center" },
        { Header: "Action", accessor: "action", align: "center" },
      ];

      const rows = subscriptions.map((sub, index) => ({
        id: index + 1,
        name: sub.name,
        validity_days: sub.validity_days,
        sell_price: sub.sell_price,
        original_price: sub.original_price,
        expiry_date: sub.expiry_date,
        allowed_number_of_devices: sub.allowed_number_of_devices,
        description: sub.description,
        status: sub.status,
        action: (
          <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
            <button
              onClick={() => openUpdatePage(sub)}
              style={buttonStyle("#007bff")}
              onMouseOver={(e) => (e.target.style.color = "#007bff")}
              onMouseOut={(e) => (e.target.style.color = "#7b809a")}
            >
              Update
            </button>
            <button
              onClick={() => handleDelete(sub.id)}
              style={{
                color: "#dc3545",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}

            >
              Delete
            </button>
          </div>
        ),
      }));

      setTableData({ columns, rows });
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };

  const buttonStyle = () => ({
    color: "#7b809a",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "14px",
  });

  const openUpdatePage = (subscription) => {
    navigate(`/update-subscription/${subscription.id}`, { state: subscription });
  };

  const handleDelete = async (subscriptionId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        await Api.deleteSubscription(subscriptionId);
        Swal.fire("Deleted!", "Subscription has been deleted.", "success");
        fetchSubscriptions();
      }
    } catch (error) {
      console.error("Error deleting subscription:", error);
      Swal.fire("Error!", "Failed to delete subscription.", "error");
    }
  };

  useEffect(() => {
    fetchSubscriptions();
  }, [[refreshTrigger]]);

  return (
    <DataTable
      table={tableData}
      entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
      canSearch
      showTotalEntries
      isSorted={false}
    />
  );
};

export default SubscriptionTable;
